import {extend} from "vee-validate";
import {email, max, max_value, min, min_value, required} from "vee-validate/dist/rules";
import moment from "moment";

extend('required', {
    ...required,
    message: 'Het {_field_} veld is verplicht'
});

extend('email', {
    ...email,
    message: 'Het email adres is niet geldig'
});

extend('min_value', {
    ...min_value,
    message: 'Het {_field_} veld moet minstens {min} zijn'
});

extend('max_value', {
    ...max_value,
    message: 'Het {_field_} veld mag niet meer dan {max} zijn'
});

extend('min', {
    ...min,
    message: 'Het {_field_} veld moet minstens {length} letters bevatten'
});

extend('max', {
    ...max,
    message: 'Het {_field_} veld mag niet meer dan {length} letters bevatten'
});

extend('notSame', {
    params: ['target'],
    validate(value, {target}) {
        return value !== target;
    },
    message: 'Het {_field_} veld mag niet dezelfde waarde hebben als het {target} veld'
});

extend('bothRequiredOrBothNot', {
    params: ['target'],
    validate(value, {target}) {
        return !!value === !!target;
    },
    message: 'Indien het {_field_} veld ingevuld is moet het {target} veld ook ingevuld worden'
});

extend('date_in_month', {
    params: ['yearMonth'],
    validate(value, {yearMonth}) {
        const firstDate = moment(yearMonth).startOf('month');
        const lastDate = moment(yearMonth).endOf('month');
        const chosenDate = moment(value);

        return chosenDate.isSameOrAfter(firstDate) && chosenDate.isSameOrBefore(lastDate);
    },
    message: 'Het {_field_} veld moet een dag in de maand {yearMonth} zijn'
});

extend('same_or_before_field', {
    params: ['target'],
    validate(value, {target}) {
        if (!target) {
            return true;
        }

        const earliestDate = moment(value);
        const latestDate = moment(target);

        return earliestDate.isSameOrBefore(latestDate);
    },
    message: 'Het {_field_} veld moet een datum voor het {target} veld zijn'
});

extend('before_date', {
    params: ['target'],
    validate(value, {target}) {
        if (!target) {
            return true;
        }

        const earliestDate = moment(value);
        const latestDate = moment(target);

        return earliestDate.isBefore(latestDate);
    },
    message: 'Het {_field_} veld moet een datum voor het {target} veld zijn'
});

extend('after_date', {
    params: ['target'],
    validate(value, {target}) {
        if (!target) {
            return true;
        }

        const latestDate = moment(value);
        const earliestDate = moment(target);

        return latestDate.isAfter(earliestDate);
    },
    message: 'Het {_field_} veld moet een datum voor het {target} veld zijn'
});

extend('same_or_after_field', {
    params: ['target'],
    validate(value, {target}) {
        if (!target) {
            return true;
        }

        const latestDate = moment(value);
        const earliestDate = moment(target);

        return latestDate.isSameOrAfter(earliestDate);
    },
    message: 'Het {_field_} veld moet een datum na het {target} veld zijn'
});

extend('same_or_after_date', {
    params: ['date'],
    validate(value, {date}) {
        const dateToCheck = moment(value);
        const earlierDate = moment(date);

        return dateToCheck.isSameOrAfter(earlierDate);
    },
    message: 'Het {_field_} veld moet een datum na {date} zijn'
});

extend('overlap_with_other_period', {
    params: ['overlapResult'],
    validate({overlapResult}) {
        return overlapResult;
    },
    message: 'De {_field_} mag niet overlappen met data van andere periodes'
});